export default __webpack_public_path__ + "static/media/img_22.e6f8adfc.jpg";